var _defs, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCodiiiMascot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 213.05 213.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #231f20;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #e97124;\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n\n      .cls-4 {\n        fill: #010101;\n        filter: url(#drop-shadow-1);\n      }\n    "), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-1",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.17,
    dy: 1.17
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#010101",
    floodOpacity: 0.6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    width: 213.05,
    height: 213.05,
    rx: 43.34,
    ry: 43.34
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M42.13,76.32c-4.92,2.55-8.01,7.63-8.01,13.17v48.13c0,2.98,1.68,5.71,4.34,7.06l60.72,30.66c.85.44,1.87.44,2.72,0l69.02-35.69c4.92-2.55,8.01-7.63,8.01-13.17v-48.85c-.01-3.03-1.74-5.79-4.47-7.11l-37.79-18.33-12.48-6.41c-7.34-3.78-16.06-3.74-23.38.09l-16.05,8.41-42.64,22.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M100.54,176.09c-.53,0-1.07-.13-1.56-.38l-60.72-30.66c-2.82-1.42-4.57-4.27-4.57-7.44v-48.13c0-5.72,3.16-10.91,8.24-13.54l42.64-22.05,16.05-8.41c7.43-3.89,16.31-3.93,23.77-.09l12.48,6.41,37.78,18.33c2.85,1.38,4.69,4.32,4.69,7.49v48.85c.01,5.72-3.15,10.91-8.23,13.54l-69.02,35.69c-.49.25-1.02.38-1.56.38ZM42.32,76.7c-4.8,2.48-7.79,7.38-7.79,12.79v48.13c0,2.84,1.58,5.4,4.11,6.68l60.72,30.66c.73.38,1.61.38,2.34,0l69.02-35.69c4.8-2.48,7.79-7.38,7.79-12.79v-48.85c-.01-2.85-1.67-5.49-4.23-6.73l-37.79-18.33-12.49-6.42c-7.21-3.71-15.81-3.68-22.99.09l-16.05,8.41-42.64,22.05Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M51.28,110.95v24.11c0,1.11.62,2.12,1.6,2.63l19.37,10.01c1.97,1.02,4.33-.41,4.33-2.63v-24.11c0-1.11-.62-2.12-1.6-2.63l-19.37-10.01c-1.97-1.02-4.33.41-4.33,2.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M73.62,148.47c-.53,0-1.06-.13-1.56-.38l-19.37-10.01c-1.13-.58-1.83-1.74-1.83-3.01v-24.11c0-1.19.61-2.27,1.63-2.89,1.02-.62,2.26-.66,3.32-.12l19.37,10.01c1.13.58,1.83,1.74,1.83,3.01v24.11c0,1.19-.61,2.27-1.63,2.89-.54.33-1.15.5-1.76.5ZM54.25,108.41c-.46,0-.91.12-1.32.37-.76.46-1.22,1.28-1.22,2.17v24.11c0,.95.53,1.82,1.37,2.26l19.37,10.01c.79.41,1.72.38,2.49-.09.76-.46,1.22-1.28,1.22-2.17v-24.11c0-.95-.53-1.82-1.37-2.26l-19.37-10.01c-.37-.19-.77-.29-1.17-.29Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M110.7,115.58l54.71-28.29c3.47-1.79,7.6.72,7.6,4.63v35.22c0,2.92-1.63,5.6-4.22,6.94l-54.28,28.07c-3.66,1.89-8.03-.76-8.03-4.89v-34.74c0-2.92,1.63-5.6,4.22-6.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M100.43,113.33c-1.63,0-3.25-.38-4.73-1.15l-54.23-27.4.38-.76,54.23,27.4c2.72,1.41,5.97,1.41,8.69,0l67.6-34.96.39.75-67.6,34.96c-1.48.77-3.11,1.15-4.73,1.15Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "95.27 86.7 91.46 86.7 91.46 71.66 81.74 64.86 83.93 61.74 95.27 69.67 95.27 86.7"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 121.92,
    y: 39.94,
    width: 3.81,
    height: 33.11
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 123.83,
    cy: 34.99,
    r: 5.72
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M123.83,41.13c-3.39,0-6.15-2.76-6.15-6.15s2.76-6.15,6.15-6.15,6.15,2.76,6.15,6.15-2.76,6.15-6.15,6.15ZM123.83,29.69c-2.92,0-5.3,2.38-5.3,5.3s2.38,5.3,5.3,5.3,5.3-2.38,5.3-5.3-2.38-5.3-5.3-5.3Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 126.22,
    cy: 124.09,
    rx: 6.72,
    ry: 4.15,
    transform: "translate(-41.93 179.38) rotate(-62.71)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 156.79,
    cy: 106.41,
    rx: 6.72,
    ry: 4.15,
    transform: "translate(-9.65 196.97) rotate(-62.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M130.23,133.43l22.82-13.31c.99-.58,2.21.2,2.12,1.34h0c-3.83,15.58-13.11,20.69-17.04,22.01-1.33.45-2.77.66-4.14.36-4.33-.96-6.66-4.36-5.72-7.92h0c.32-1.04,1.02-1.92,1.96-2.47Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 80.36,
    cy: 60.9,
    r: 5.72
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M80.36,67.05c-3.39,0-6.15-2.76-6.15-6.15s2.76-6.15,6.15-6.15,6.15,2.76,6.15,6.15-2.76,6.15-6.15,6.15ZM80.36,55.6c-2.92,0-5.3,2.38-5.3,5.3s2.38,5.3,5.3,5.3,5.3-2.38,5.3-5.3-2.38-5.3-5.3-5.3Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodiiiMascot);
export default __webpack_public_path__ + "static/media/codiii-mascot.1edfbd758ebd83096581f48a4b532cdb.svg";
export { ForwardRef as ReactComponent };